var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssignment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6495 11.8997C19.6503 11.8989 19.6502 11.8976 19.6494 11.8969L18.7967 11.2143C18.3854 10.8855 17.7767 10.941 17.4377 11.34L17.0474 11.7988L12.5929 16.9903C12.5342 17.0587 12.4951 17.1417 12.4797 17.2305L12.2516 18.5474L12.147 19.1516C12.0815 19.5298 12.4488 19.8377 12.8097 19.7072L13.4223 19.4856L14.7209 19.0159C14.802 18.9866 14.8741 18.9368 14.9303 18.8714L19.3888 13.6767L19.7791 13.2178C20.1181 12.8189 20.0608 12.2285 19.6495 11.8997Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.175 18H5C4.44771 18 4 17.5523 4 17V5C4 4.44772 4.44772 4 5 4H16C16.5523 4 17 4.44772 17 5V9.25",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42969 8L13.144 8",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42969 11L12.0011 11",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignment);
export default __webpack_public_path__ + "static/media/assignment.2c868c52b59767f2e9613085de06735e.svg";
export { ForwardRef as ReactComponent };